import styled from "styled-components";

import { AuthModalButtonContainer } from "shared/components/organisms/AuthModal/components/atoms/AuthModalButton/styles";

import { AuthModalBottomDescription } from "../../../../atoms/AuthModalBottomDescription/styles";

export const LoginComponentContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  width: 100%;

  padding-bottom: 1.25rem;

  ${AuthModalButtonContainer} {
    width: 100%;
  }

  ${AuthModalBottomDescription} {
    margin: 0;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    width: 100%;
  }

  .auth-login-forgot-password {
    color: ${({ theme }) => theme.authModal.primaryText};
    height: auto;
    padding: 0;
  }
`;

export const AuthModalLoginButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  [data-testid="auth-modal-submit-button"] {
    box-shadow: 0px 2px 40px 0px #00000040;
  }
`;
